import React from "react";
import "bootstrap/dist/css/bootstrap.css";
import WeeklyResult from "./WeeklyProrateCalc";
import BiWeeklyResult from "./BiWeeklyProrateCalc";
import ColumbiaRateTableData from "./ColumbiaRateTableData.json";
import CornellRateTableData from "./CornellRateTableData.json";
import MethodistRateTableData from "./MethodistRateTableData.json";
import LowerManhattanRateTableData from "./LowerManhattanRateTableData.json";
import AllenRateTableData from "./AllenRateTableData.json";
import CreateSelect from "./CreateParkTypeSelect";
import CreateLocSelect from "./CreateLocationSelect";
import { Typography } from "@mui/material";

var selectedCampusList;
var selectedSelectValue;
function SelectCampusRateList() {
  if (document.getElementById("campusname").value === "Columbia") {
    selectedCampusList = ColumbiaRateTableData;
  } else if (document.getElementById("campusname").value === "Cornell") {
    selectedCampusList = CornellRateTableData;
  } else if (document.getElementById("campusname").value === "Methodist") {
    selectedCampusList = MethodistRateTableData;
  } else if (document.getElementById("campusname").value === "Lower Manhattan") {
    selectedCampusList = LowerManhattanRateTableData;
  } else if (document.getElementById("campusname").value === "Allen") {
    selectedCampusList = AllenRateTableData;
  }
  return selectedCampusList;
}

const ProrateForm = () => {
  // const [show, setShow] = useState(false);

  // const handleClose = () => setShow(false);
  // const handleShow = () => setShow(true);

  var areLocationsLoaded = false;
  var areParkTypesLoaded = false;
  var areCampusesLoaded = false;
  var curr = new Date();
  curr.setDate(curr.getDate());
  var currDate = curr.toISOString().substring(0, 10);

  return (
    <div
      className="container col"
      style={{ marginLeft: "10px", marginTop: "5px" }}
    >
      <div className="row input-group mb-3">
        <div>
          <Typography
            variant="subtitle1"
            sx={{
              paddingLeft: "10px",
              color: "blue",
              backgroundColor: "lightgray",
              fontSize: "14px"
            }}
          >
            The calculator below determines the amount owed before the employee
            begins parking. If and when the start date changes, the amount owed
            will vary. The parking office will provide a rate breakdown that
            includes the prorated amount owed, the date of the first payroll
            deduction, and the card or RFID tag charge, which is not included in
            this rate. The calculator below is only for employees who are
            eligible for payroll deduction and wish to enroll. If you are not
            eligible for the payroll deduction program or wish to be billed
            monthly, please contact the parking office for more information.
          </Typography>
        </div>

        <br />
        <div>
          <div id="calcDataDiv">
            <div className="input-group mb-3" style={{ marginTop: "10px" }}>
              <div>
                <span className="input-group-text" id="basic-addon1">
                  <input
                    type="radio"
                    id="biweekly"
                    name="cycle"
                    value={"biweekly"}
                    defaultChecked="true"
                    style={{ marginRight: "10px" }}
                  />
                  Biweekly Pay Cycle
                </span>
              </div>
              <div style={{ marginLeft: "20px" }}>
                <span className="input-group-text" id="basic-addon1">
                  <input
                    type="radio"
                    id="weekly"
                    name="cycle"
                    value={"weekly"}
                    style={{ marginRight: "10px" }}
                  />
                  Weekly Pay Cycle
                </span>
              </div>
              {/* <div style={{ marginLeft: "20px" }}>
            <span className="input-group-text" id="basic-addon1">
              <input
                type="radio"
                id="billing"
                name="billing"
                value="billing"
                style={{ marginRight: "10px" }}
                disabled
              />
              Monthly Billing Cycle
            </span>
          </div> */}
            </div>
            <div className="col input-group mb-3 col">
              <span className="input-group-text" id="basic-addon1">
                Select Campus
              </span>
              <select
                className="form-select float-start"
                id="campusname"
                name="campusname"
                onChange={() => {
                  // console.log(document.getElementById.innerHTML);
                  //if (document.getElementById("campusname").value === "Select") {
                  SelectCampusRateList();
                  // console.log(e.target.value)
                  // CreateLocSelect(e.target.value, selectedCampusList, "loc");
                  //}
                  selectedSelectValue =
                    document.getElementById("campusname").value;
                  document.getElementById("loc").innerHTML = "Select Location";
                  areLocationsLoaded = false;
                  areParkTypesLoaded = false;
                  areCampusesLoaded = true;
                }}
              >
                <option value="Select">Select Campus</option>
                <option value="Columbia">Columbia</option>
                <option value="Cornell">Cornell</option>
                <option value="Methodist">Methodist</option>
                <option value="Lower Manhattan">Lower Manhattan</option>
                <option value="Allen">Allen Hospital</option>
              </select>
            </div>
            <div>
              <div className="input-group mb-3 col">
                <span className="input-group-text" id="basic-addon1">
                  Select Location
                </span>
                <select
                  className="form-control float-start text-start"
                  placeholder="Select Location"
                  id="loc"
                  name="loc"
                  onClick={() => {
                    // console.log(
                    //   selectedSelectValue,
                    //   document.getElementById("campusname").value,
                    //   1
                    // );
                    if (
                      areLocationsLoaded === false &&
                      areCampusesLoaded === true
                    ) {
                      SelectCampusRateList();
                      // console.log(
                      //   document.getElementById("campusname").value,
                      //   2,
                      //   selectedCampusList
                      // );
                      CreateLocSelect(
                        selectedSelectValue,
                        selectedCampusList,
                        "loc"
                      );
                      areLocationsLoaded = true;
                      areParkTypesLoaded = false;
                      document.getElementById("parktype").innerHTML =
                        "Select Parking Type";
                    }
                  }}
                >
                  <option value="SelectLoc">Select Location</option>
                </select>
              </div>
            </div>
            <div>
              <div className="input-group mb-3 col">
                <span className="input-group-text" id="basic-addon1">
                  Select Parking Type
                </span>
                <select
                  className="form-control float-start text-start"
                  placeholder="Select Parking Type"
                  id="parktype"
                  name="parktype"
                  onClick={() => {
                    if (
                      areParkTypesLoaded === false &&
                      areLocationsLoaded === true
                    ) {
                      SelectCampusRateList();
                      CreateSelect(
                        document.getElementById("loc").value,
                        selectedCampusList,
                        "parktype"
                      );
                      areParkTypesLoaded = true;
                      areLocationsLoaded = false;
                    }
                  }}
                >
                  <option value="selectparktype">Select Parking Type</option>
                </select>
              </div>
            </div>
            <div>
              <div className="input-group mb-3 col">
                <span className="input-group-text" id="basic-addon1">
                  Parking Start Date
                </span>
                <input
                  className="form-control float-start text-start"
                  type="date"
                  defaultValue={currDate}
                  id="dateIn"
                  name="dateIn"
                />
              </div>
            </div>
          </div>
          <div className="col input-group mb-3" id="calcDataDiv">
            <textarea
              className="form-control float-start text-start"
              rows={12}
              id="result"
              name="result"
              disabled
              style={{
                backgroundColor: "#FFFFF0",
                border: "1px solid red",
                fontSize: "13px",
                marginTop: "10px"
              }}
            ></textarea>
          </div>
        </div>
        <button
          className="btn btn-primary btn-md calcBtn"
          style={{ width: "10%", marginLeft: "20px" }}
          onClick={() => {
            var d1 = new Date(document.getElementById("dateIn").value);
            var campusName = document.getElementById("campusname").value;
            SelectCampusRateList();
            if (document.getElementById("biweekly").checked) {
              // console.log(d1);
              document.getElementById("result").value = BiWeeklyResult(
                d1,
                selectedCampusList,
                campusName,
                document.getElementById("loc").value,
                document.getElementById("parktype").value
              );
            } else if (document.getElementById("weekly").checked) {
              document.getElementById("result").value = WeeklyResult(
                d1,
                selectedCampusList,
                campusName,
                document.getElementById("loc").value,
                document.getElementById("parktype").value
              );
            }
          }}
        >
          Calculate
        </button>
      </div>
    </div>
  );
};

export default ProrateForm;
